import React, { useEffect } from "react";
import { ImCheckmark, ImCross } from "react-icons/im";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";

export interface PasswordCheckListProps {
    password: string;
    confirmPassword?: string;
    minimumCharacters?: number;
    shouldHaveAtLeastOneLetter?: boolean;
    shouldHaveAtLeastOneNumber?: boolean;
    shouldHaveAtLeastOneCapitalLetter?: boolean;
    shouldHaveAtLeastOneLowercaseLetter?: boolean;
    shouldHaveAtLeastOneSpecialChar?: boolean;
    matchPasswords?: boolean;
    onChange: (isValid: boolean) => void;
}

export default function PasswordCheckList(props: PasswordCheckListProps) {
    const PasswordCheckItem = (textId: string, valid: boolean) => {
        return (
            <Row
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                }}
            >
                <Col md={1} sm={1} xs={1}>
                    {valid === true ? <ImCheckmark color="green" /> : <ImCross color="red" />}
                </Col>
                <Col
                    style={{
                        textAlign: "left",
                        fontSize: "0.9em",
                        fontWeight: 500,
                        opacity: valid === true ? 1 : 0.75,
                    }}
                >
                    <FormattedMessage id={textId} />
                </Col>
            </Row>
        );
    };

    //Verifica se tem mais do que x caracteres
    const validateCharacters = () => {
        if (typeof props.minimumCharacters != "undefined") {
            if (typeof props.password == "undefined") return false;
            if (props.password == null) return false;
            if (props.password.length < props.minimumCharacters) return false;
        }

        return true;
    };

    const validateHasOneLowerCaseLetter = () => {
        if (
            typeof props.shouldHaveAtLeastOneLowercaseLetter != "undefined" &&
            props.shouldHaveAtLeastOneLowercaseLetter === true
        ) {
            var checkOneLetter = /^(.*[a-z].*)$/.test(props.password);
            return checkOneLetter;
        }

        return true;
    };

    const validateHasOneLetter = () => {
        if (
            typeof props.shouldHaveAtLeastOneLetter != "undefined" &&
            props.shouldHaveAtLeastOneLetter === true
        ) {
            var checkOneLetter = /^(.*[a-zA-Z].*)$/.test(props.password);
            return checkOneLetter;
        }

        return true;
    };

    const validateHasOneCapitalLetter = () => {
        if (
            typeof props.shouldHaveAtLeastOneCapitalLetter != "undefined" &&
            props.shouldHaveAtLeastOneCapitalLetter === true
        ) {
            var checkOneLetter = /^(.*[A-Z].*)$/.test(props.password);
            return checkOneLetter;
        }

        return true;
    };

    const validateHasOneNumber = () => {
        if (
            typeof props.shouldHaveAtLeastOneNumber != "undefined" &&
            props.shouldHaveAtLeastOneNumber === true
        ) {
            var checkOneLetter = /^(.*\d.*)$/.test(props.password);
            return checkOneLetter;
        }

        return true;
    };

    const validateHasSpecialChar = () => {
        if (
            typeof props.shouldHaveAtLeastOneSpecialChar !== "undefined" &&
            props.shouldHaveAtLeastOneSpecialChar === true
        ) {
            var regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            var hasSpecialChar = regex.test(props.password);
            return hasSpecialChar;
        }

        return true;
    };

    const validateMatchPasswords = () => {
        if (typeof props.matchPasswords != "undefined" && props.matchPasswords === true) {
            if (props.password.length <= 0) return false;
            if (props.password !== props.confirmPassword) return false;
        }

        return true;
    };

    const verifyIfValid = () => {
        var isValid: boolean =
            validateCharacters() === true &&
            validateHasOneLowerCaseLetter() === true &&
            validateHasOneLetter() === true &&
            validateHasOneCapitalLetter() === true &&
            validateHasOneNumber() === true &&
            validateMatchPasswords() === true &&
            validateHasSpecialChar() === true;
        props.onChange(isValid);
    };

    useEffect(() => {
        verifyIfValid();
        return () => {};
    }, [props.password]);

    useEffect(() => {
        verifyIfValid();
        return () => {};
    }, [props.confirmPassword]);

    return (
        <div>
            {typeof props.minimumCharacters != "undefined" &&
                PasswordCheckItem("Password.MinimumChars", validateCharacters())}

            {typeof props.shouldHaveAtLeastOneLetter != "undefined" &&
                props.shouldHaveAtLeastOneLetter === true &&
                PasswordCheckItem("Password.AtLeastOneLetter", validateHasOneLetter())}

            {typeof props.shouldHaveAtLeastOneNumber != "undefined" &&
                props.shouldHaveAtLeastOneNumber === true &&
                PasswordCheckItem("Password.AtLeastOneDigit", validateHasOneNumber())}

            {typeof props.shouldHaveAtLeastOneLowercaseLetter != "undefined" &&
                props.shouldHaveAtLeastOneLowercaseLetter === true &&
                PasswordCheckItem("Password.AtLeastOneUpperCase", validateHasOneLowerCaseLetter())}

            {typeof props.shouldHaveAtLeastOneCapitalLetter != "undefined" &&
                props.shouldHaveAtLeastOneCapitalLetter === true &&
                PasswordCheckItem("Password.AtLeastOneLowerCase", validateHasOneCapitalLetter())}

            {typeof props.shouldHaveAtLeastOneSpecialChar !== "undefined" &&
                props.shouldHaveAtLeastOneSpecialChar === true &&
                PasswordCheckItem("Password.AtLeastOneSpecialChar", validateHasSpecialChar())}

            {typeof props.matchPasswords != "undefined" &&
                props.matchPasswords === true &&
                PasswordCheckItem("Password.MatchPasswords", validateMatchPasswords())}
        </div>
    );
}
